export const getFileTypes = (file) => {
    const rootType = file.type.split('/')[0];
    const subType = file.type.split('/')[1];
    return {
        rootType,
        subType,
    };
};
